// Module
var code = `<div class="mainSideBarButtonClass {{.additionalClass}}"
     name="{{.name}}"
     on-click="componentClick"
     on-mouseover="componentOver"
     on-mousedown="@this.onMouseDown(event)"
     {{^.enabled}}disabled="" {{/}}
     {{#if .canCheck}}{{#.checked}}checked{{/}}{{/if}}
     as-tooltip="tooltip"
     style="{{>visibility}}">

    <div class="image-button-plain{{#if .checked}} checked{{/if}}">
        {{#if .counter}}
            <div class="{{.counter > 99 ? .counterStyle + '-plus' : .counterStyle}}">
                {{.counter > 99 ? '99+':.counter}}
            </div>
        {{/if}}

        {{#if .svgStyle}}
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.svgStyle}}"></use>
            </svg>
        {{else}}
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.name}}"></use>
            </svg>
        {{/if}}
    </div>
</div>`;
// Exports
export default code;